export const mvnos = [
  {
    name: "Mint Mobile",
    logo: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=80&h=80&fit=crop&auto=format",
    color: "#00c389",
    tagline: "Best Overall Value",
    badge: "Most Popular",
    network: "T-Mobile",
    plans: [
      { data: "5GB", price: 15 },
      { data: "15GB", price: 20 },
      { data: "20GB", price: 25 },
      { data: "Unlimited", price: 30 },
    ],
  },
  {
    name: "Visible",
    logo: "https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=80&h=80&fit=crop&auto=format",
    color: "#5c2d91",
    tagline: "Truly Unlimited",
    badge: "Best Unlimited",
    network: "Verizon",
    plans: [
      { data: "Unlimited", price: 25 },
      { data: "Unlimited+", price: 45 },
    ],
  },
  {
    name: "Cricket Wireless",
    logo: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=80&h=80&fit=crop&auto=format",
    color: "#00a94f",
    tagline: "No Annual Contract",
    badge: "No Contract",
    network: "AT&T",
    plans: [
      { data: "2GB", price: 25 },
      { data: "5GB", price: 30 },
      { data: "10GB", price: 40 },
      { data: "Unlimited", price: 55 },
    ],
  },
  {
    name: "Tello",
    logo: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=80&h=80&fit=crop&auto=format",
    color: "#f7a800",
    tagline: "Build Your Own Plan",
    badge: "Most Flexible",
    network: "T-Mobile",
    plans: [
      { data: "1GB", price: 8 },
      { data: "2GB", price: 10 },
      { data: "5GB", price: 14 },
      { data: "Unlimited", price: 25 },
    ],
  },
  {
    name: "Google Fi",
    logo: "https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=80&h=80&fit=crop&auto=format",
    color: "#4285f4",
    tagline: "Multi-Network Coverage",
    badge: "Best Coverage",
    network: "T-Mobile / US Cellular",
    plans: [
      { data: "Flexible", price: 20 },
      { data: "Simply Unlimited", price: 35 },
      { data: "Unlimited Plus", price: 45 },
    ],
  },
  {
    name: "US Mobile",
    logo: "https://images.unsplash.com/photo-1544866092-1677b2a83b72?w=80&h=80&fit=crop&auto=format",
    color: "#e31837",
    tagline: "Choose Your Network",
    badge: "Best for Families",
    network: "Verizon / T-Mobile",
    plans: [
      { data: "2GB", price: 10 },
      { data: "5GB", price: 15 },
      { data: "Unlimited", price: 25 },
      { data: "Unlimited Premium", price: 35 },
    ],
  },
];